<template>
  <div class="container" id="reservation-cancel-now">
    <div id="cancel-container" class="_dp-n">
      <div class="fixedFloatBar">
        <el-button class="cancel-button" @click="clickCancel">ยกเลิก</el-button>
        <el-button type="primary" @click="clickApprove" :disabled="isDisabledAccept">ยืนยัน</el-button>
      </div>
      <div class="form-container">
        <el-form class="form" ref="form" :model="form" label-width="270px">
          <el-row>
            <el-col :span='18'>
              <span class="head alignRight">ยกเลิกบริการ{{ cancelNowHeader }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span='18'>
              <span class="subhead alignRight">เลือกวันที่ต้องการหยุดใช้บริการ</span>
            </el-col>
          </el-row>
          <el-row>
            <div class="calendar-container">
              <div class="btn-calendar-container">
                <el-button icon="el-icon-arrow-left" @click.native="goPreviousMonth" style="margin-top: -4px;" />
                <el-button icon="el-icon-arrow-right"  @click.native="goNextMonth" style="margin-left: 599px; min-width: 60px; max-width: 60px; margin-top: -4px;" />
              </div>
              <day-picker-calendar id="cancelNowCalendar" v-model="form.dates" ref="cancelNowCalendar" :isAllowAddEvent='false' :maxDate="allowDates.length" :allowDates="allowDates" @select="selectCalendar" :typeCalendar="checkTypeCalendar" />
            </div>
          </el-row>
        </el-form>
      </div>
    </div>

    <!-- Confirm Date Dialog -->
    <el-dialog :visible.sync="control.showConfirmDateDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div class="header-18" style="margin-left: 17px; font-family: 'Sukhumvit-Medium';">ต้องการยกเลิกบริการ<br>ตั้งแต่วันที่ {{ confirmDateDetail }} ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleConfirmDate(false)">ไม่</el-button>
        <el-button type="primary" @click="handleConfirmDate(true)" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Input Reason Dialog -->
    <el-dialog :visible.sync="control.showReasonDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="35%">
      <div class="header-bold-18" style="margin-bottom: 8px;">สาเหตุที่ยกเลิกบริการ</div>
      <p style="margin-bottom: 0px;"><el-radio label="bad" style="font-size: 18px;" v-model="form.reason.type" @change="changeReasonType()">Bad Ending</el-radio></p>
      <div v-if="form.reason.type === 'bad'">
        <div style="margin-left: 25px; display: flex; align-items: baseline;">
          <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">ที่มา </span>
          <el-select v-model="form.reason.from" placeholder="เลือกที่มา" @change="changeReasonFrom()" style="margin: 0 24px 14px 0; max-width: 100px; min-width: 100px;">
            <el-option key="Customer" label="ลูกค้า" value="ลูกค้า"></el-option>
            <el-option key="Carepro" label="ผู้ดูแล" value="ผู้ดูแล"></el-option>
          </el-select>
          <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">สาเหตุ </span>
          <el-select v-if="form.reason.from !== 'ผู้ดูแล'" v-model="form.reason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 14px 0; width: 100%;">
            <el-option key="RelativeCare" label="ญาติดูแลแทน" value="ญาติดูแลแทน"></el-option>
            <el-option key="PrevCaregiverCare" label="ผู้ดูแลเก่าดูแลแทน" value="ผู้ดูแลเก่าดูแลแทน"></el-option>
            <el-option key="GetCareproFromOther" label="ได้คนจากที่อื่น" value="ได้คนจากที่อื่น"></el-option>
            <el-option key="DirectHire" label="จ้างตรง" value="จ้างตรง"></el-option>
            <el-option key="NoSkill" label="ไม่มีผู้ดูแลคุณสมบัติที่ต้องการ" value="ไม่มีผู้ดูแลคุณสมบัติที่ต้องการ"></el-option>
            <el-option key="WaitCaregiverHAH" label="รอผู้ดูแลจาก HAH คนเดิม" value="รอผู้ดูแลจาก HAH คนเดิม"></el-option>
            <el-option key="Expensive" label="ราคาแพง / ไม่มีส่วนลด" value="ราคาแพง / ไม่มีส่วนลด"></el-option>
            <el-option key="WantCancelCreditCard" label="ต้องการยกเลิกตัดบัตรเครดิต" value="ต้องการยกเลิกตัดบัตรเครดิต"></el-option>
            <el-option key="DontUnderstand" label="ไม่เข้าใจเงื่อนไขการให้บริการ" value="ไม่เข้าใจเงื่อนไขการให้บริการ"></el-option>
            <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
          </el-select>
          <el-select v-if="form.reason.from === 'ผู้ดูแล'" v-model="form.reason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 32px 0;">
            <el-option key="NoCG" label="ไม่มีผู้ดูแลแทนงาน" value="ไม่มีผู้ดูแลแทนงาน"></el-option>
            <el-option key="NoContractCG" label="ไม่มีผู้ดูแลต่อสัญญา" value="ไม่มีผู้ดูแลต่อสัญญา"></el-option>
            <el-option key="Covid" label="คนไข้ตรวจพบโรคติดต่อ" value="คนไข้ตรวจพบโรคติดต่อ"></el-option>
            <el-option key="NoSkill" label="ปัญหาทักษะ ความชำนาญ" value="ปัญหาทักษะ ความชำนาญ"></el-option>
            <el-option key="NoSoftSkill" label="ปัญหา Soft skill" value="ปัญหา Soft skill"></el-option>
            <el-option key="NotSatisfied" label="ลูกค้าไม่พอใจการทำงาน" value="ลูกค้าไม่พอใจการทำงาน"></el-option>
            <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
          </el-select>
        </div>
      </div>

      <p style="margin-bottom: 0px;"><el-radio label="good" style="font-size: 18px;" v-model="form.reason.type" @change="changeReasonType()">Good Ending</el-radio></p>
        <div v-if="form.reason.type === 'good'">
           <div style="margin-left: 25px; display: flex; align-items: baseline;">
           <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">ที่มา </span>
            <el-select v-model="form.reason.from" placeholder="เลือกที่มา" @change="changeReasonFrom()" style="margin: 0 24px 14px 0;  max-width: 100px; min-width: 100px;">
              <el-option key="Customer" label="ลูกค้า" value="ลูกค้า"></el-option>
              <el-option key="Other" label="อื่นๆ" value="อื่นๆ"></el-option>
            </el-select>
            <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">สาเหตุ </span>
            <el-select v-if="form.reason.from !== 'อื่นๆ'" v-model="form.reason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 14px 0;  width: 100%;">
              <el-option key="Improves" label="คนไข้อาการดีขึ้น" value="คนไข้อาการดีขึ้น"></el-option>
              <el-option key="Dead" label="คนไข้เสียชีวิต" value="คนไข้เสียชีวิต"></el-option>
              <el-option key="ICU" label="คนไข้เข้ารพ./ICU/เนอร์สซิ่งโฮม" value="คนไข้เข้ารพ./ICU/เนอร์สซิ่งโฮม"></el-option>
              <el-option key="Behavior" label="พฤติกรรมของคนไข้/ญาติ" value="พฤติกรรมของคนไข้/ญาติ"></el-option>
              <el-option key="Covid" label="คนไข้ตรวจพบโควิด" value="คนไข้ตรวจพบโควิด"></el-option>
              <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
            </el-select>
            <el-select v-if="form.reason.from === 'อื่นๆ'" v-model="form.reason.reason" placeholder="อื่นๆ (โปรดระบุ)" style="margin: 0 0 14px 0;  width: 100%;" disabled>
              <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
            </el-select>
          </div>
        </div>

      <p style="margin-bottom: 0px;"><el-radio label="unknown" style="font-size: 18px;" v-model="form.reason.type" @change="changeReasonType()">Unknown</el-radio></p>

      <el-row style="margin-top: 100px;">
        <el-col :span="4">
          <span style="font-size: 18px;">รายละเอียด</span>
        </el-col>
        <el-col :span="18">
          <el-input style="margin-left: 8px;" type="textarea" rows="3" width="65%" v-model="form.reason.detail" @keydown="inputHandler" />
        </el-col>
      </el-row>

      <span class="dialog-footer" slot="footer">
        <el-button type="primary" @click="saveReason()" :disabled="isDisabledSaveReason" class="edit">ต่อไป</el-button>
      </span>
    </el-dialog>

    <!-- Do You Want to Refund Dialog -->
    <el-dialog :visible.sync="control.showConfirmRefundDialog" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="header-18" style="margin-left: 17px; font-family: 'Sukhumvit-Medium';">ต้องคืนเงินให้กับลูกค้าหรือไม่?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleRefund(false)">ไม่</el-button>
        <el-button type="primary" @click="handleRefund(true)" class="edit">คืนเงิน</el-button>
      </span>
    </el-dialog>

    <!-- Refund Dialog -->
    <el-dialog id="refund" :visible.sync="control.showRefundDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 9vh;" width="30%" class="refund-dialog">
      <div class="title" style="margin-bottom: 8px;">คืนเงิน</div>
      <div style="display: flex;">
        <img src="https://storage.healthathome.in.th/3dc4abc2-b2cd-4655-90fb-b679c2002a92.svg" style="align-self: flex-start; margin-top: 7px;">
        <div style="margin-left: 20px">
          <p class="detail black">จำนวนเวรที่ยกเลิก {{ refundData.shift }} เวร</p>
          <p class="detail" style="margin-top: -6px;" v-for="d in refundData.cancelDates" :key="d">{{ d }}</p>
        </div>
      </div>
      <div style="display: flex; margin-top: 16px;">
        <img src="https://storage.healthathome.in.th/31aabb27-c50d-46e2-94d2-b9f1d0d0b406.svg" style="align-self: flex-start; margin-top: 7px;">
        <div style="margin-left: 20px; width: 100%;">
          <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">
            <p class="detail">คืนเงิน {{ refundData.shift }} เวร (รวมค่าอาหาร)</p>
            <p class="detail">{{ refundData.totalPrice }}</p>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%; align-items: baseline;">
            <div style="display: flex; align-items: baseline;">
              <p class="detail" style="width: 31px">หัก</p>
              <el-input v-model.number="refundData.chargePercent" @input="calculateRefund"/>
              <p class="detail" style="margin-left: 8px;">%</p>
            </div>
            <p id="charge-price" class="detail">-{{ refundData.chargePrice }}</p>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%; padding-bottom: 16px; border-bottom: 1px solid #434B61;">
            <p class="detail">คืน vat {{ refundData.vatPercent }}%</p>
            <p class="detail">{{ refundData.vatPrice }}</p>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%; margin-top: 16px;">
            <p class="detail black bold">ราคาสุทธิที่ต้องคืน </p>
            <p class="detail black bold">{{ refundData.totalRefund }}</p>
          </div>
        </div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button type="primary" @click="refundAccept()" :disabled="isDisabledSaveRefund" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Success Refund Dialog -->
    <el-dialog :visible.sync="control.showRefundSuccessDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;  margin-bottom: 35px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/faa9aca8-773e-44a3-b4cf-558d8e173c21.svg" />
        <div class="header-18" style="margin-left: 17px;">เย่!  ทําการยกเลิกเรียบร้อย</div>
      </div>
    </el-dialog>

    <!-- IsPartial Dialog -->
    <el-dialog :visible.sync="control.showIsPartialDialog" :showClose="false"
      :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; align-items: flex-start; margin-top: 30px; flex-direction: column;">
        <div class="header-18" style="margin-bottom: 8px;">ยกเลิกบริการ</div>
        <el-radio-group class="group-vertical radio" v-model="isPartialForm">
          <el-radio :label="true" style="margin-bottom: 12px;">ยกเลิกบริการบางส่วน</el-radio>
          <el-radio :label="false">ยกเลิกบริการตั้งแต่รอบนี้เป็นต้นไป</el-radio>
        </el-radio-group>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="edit" type="primary" @click="handleIsPartial()" :disabled="isPartialForm === null">ยืนยัน</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss">
  ._dp-n {
    display: none !important;
  }

  .el-message-box.cancel-now {
    .el-message-box__message {
      p {
        font-weight: 500;
        font-size: 18px;
        line-height: 29px;
        color: #434B61;
      }
    }
  }
  #refund {
    .el-input {
      width: 66px;
    }
    input.error {
      border-color: #F56C6C;
      color: #F56C6C;
    }
    p.error {
      color: #F56C6C;
    }
  }
  .cancel-button {
    min-width: 80.92px;
    border: 1.5px solid #409EFF;
    transition: .2s;
    span {
      color: #409EFF;
      transition: .2s;
    }
    &:hover {
      background: #409EFF;
      transition: .2s;
      span {
        color: #FFFFFF;
        transition: .2s;
      }
    }
  }
</style>

<style lang="scss" scoped>
  $float-bar: 1000;
  .container {
    padding-top: 150px;
    padding-bottom: 0;
    padding-left: 300px;
    padding-right: 300px;
    margin-bottom: 50px;
  }
  .header-bold-18 {
    font-weight: bold;
    font-size: 18px;
    line-height: 29px;
    color: #434B61;
  }
  .header-18 {
    font-family: 'Sukhumvit-Bold';
    font-weight: 500;
    font-size: 18px;
    line-height: 29px;
    color: #434B61;
  }
  .fixedFloatBar {
    z-index: $float-bar;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background-color: white;
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  span {
    &.head {
      font-weight: 600;
      font-size: 36px;
      text-align: right;
      width: 260px;
      line-height: 57px;
      margin-bottom: 8px;
    }
    &.subhead {
      font-weight: 800;
      font-size: 18px;
      text-align: right;
      width: 260px;
      line-height: 36px;
    }
  }
  .calendar-container {
    margin-top: 45px;
    margin-bottom: 100px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 950px;
    line-height: 20px;
  }
  .btn-calendar-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: absolute;
    margin-top: -10px;
  }
  .alignRight {
    text-align: right;
  }
  .refund-dialog {
    .title {
      font-style: normal;
      font-weight: bold;
      font-size: 22px;
      line-height: 35px;
      color: #434B61;
    }
    .detail {
      font-weight: 600;
      font-size: 14px;
      line-height: 30px;
      color: #A2A7B3;
      margin: 0;
      &.black {
        color: #434B61;
      }
      &.bold {
        font-weight: bold;
      }
    }
  }
</style>

<script>
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import DayPickerCalendar from '../shared/DayPickerCalendar'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

const moment = extendMoment(Moment)
export default {
  name: 'ReservationCancelNow',
  mixins: [GenericAPIHandler],
  components: {
    DayPickerCalendar,
  },
  watch: {
    form (newVal, oldVal) {
      this.forceUpdateCalendar(newVal.dates)
    },
    refundData (newVal, oldVal) {
      if (newVal.chargePercent < 0 || newVal.chargePercent > 100) {
        document.getElementById('refund').getElementsByTagName('input')[0].classList.add('error')
        document.getElementById('charge-price').classList.add('error')
      } else {
        document.getElementById('refund').getElementsByTagName('input')[0].classList.remove('error')
        document.getElementById('charge-price').classList.remove('error')
      }
    },
    isPartial (newVal, oldVal) {
      if (newVal === null) {
        document.getElementById('cancel-container').classList.add('_dp-n')
      } else {
        document.getElementById('cancel-container').classList.remove('_dp-n')
      }
    },
  },
  data () {
    return {
      fullscreenLoading: false,
      form: {
        dates: [],
        subscription: false,
        reason: {
          from: '',
          type: '',
          detail: '',
          reason: '',
        },
        selectedDate: '',
      },
      allowDates: [],
      control: {
        showConfirmDateDialog: false,
        showReasonDialog: false,
        showConfirmRefundDialog: false,
        showRefundDialog: false,
        showRefundSuccessDialog: false,
        showIsPartialDialog: true,
      },
      refundData: {
        chargePercent: 0,
      },
      isPartialForm: null,
      isPartial: null,
      seleted: [],
    }
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    reservationId: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.prepareCancel()
  },
  computed: {
    isDisabledAccept () {
      return this.seleted.length === 0
    },
    isDisabledSaveReason () {
      return this.form.reason.type === ''
    },
    confirmDateDetail () {
      if (!this.isPartial) {
        const startDate = moment(this.form.selectedDate[0]).format('DD/MM/YYYY')
        const endDate = moment(this.form.selectedDate[this.form.selectedDate.length - 1]).format('DD/MM/YYYY')
        if (this.form.subscription) {
          return `${startDate} เป็นต้นไป`
        } else {
          return `${startDate} - ${endDate}`
        }
      } else {
        let datesList = this.calculateDateFormat()
        let datesListText = datesList[0]
        for (let i = 1; i < datesList.length; i++) {
          if (i === datesList.length - 1) datesListText += ' และ ' + datesList[i]
          else datesListText += ', ' + datesList[i]
        }
        return datesListText
      }
    },
    isDisabledSaveRefund () {
      const percent = parseInt(this.refundData.chargePercent)
      return percent < 0 || percent > 100
    },
    cancelNowHeader () {
      if (this.isPartial) {
        return 'บางส่วน'
      } else if (this.isPartial !== null) {
        return 'ตั้งแต่รอบนี้เป็นต้นไป'
      }
      return null
    },
    checkTypeCalendar () {
      if (this.isPartial) {
        return 'cancelNowPartial'
      } else {
        return 'cancelNowTotal'
      }
    },
  },
  methods: {
    async prepareCancel () {
      try {
        this.fullscreenLoading = true
        let raw = await this.$api.Reservation.preparecancel(this.reservationId)
        this.form.dates = [...raw.dates]
        this.allowDates = [...raw.dates]
        this.form.subscription = raw.subscription
        this.$refs.cancelNowCalendar.foceUpdateData(this.form.dates)
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    forceUpdateCalendar (dates) {
      this.$refs.cancelNowCalendar.foceUpdateData(dates)
    },
    goPreviousMonth () {
      this.$refs.cancelNowCalendar.previousMonth()
    },
    goNextMonth () {
      this.$refs.cancelNowCalendar.nextMonth()
    },
    clickCancel () {
      this.seleted = []
      this.$router.push({ name: 'PatientDetail', params: { id: this.id }, query: { tab: 'workcalendarTab' } })
    },
    selectCalendar (value) {
      if (!this.isPartial) {
        this.seleted = [...this.allowDates]
        this.seleted = this.seleted.filter((event) => {
          return Moment(event, 'YYYY-MM-DD').startOf('date').isSameOrAfter(Moment(value, 'YYYY-MM-DD').startOf('date'))
        })
      } else {
        this.seleted.push(value)
      }
    },
    changeReasonFrom () {
      this.form.reason.detail = ''
      this.form.reason.reason = ''
      if (this.form.reason.type === 'good' && this.form.reason.from === 'อื่นๆ') {
        this.form.reason.reason = 'อื่นๆ'
      }
    },
    changeReasonType () {
      this.form.reason.from = ''
      this.form.reason.reason = ''
      this.form.reason.detail = ''
    },
    inputHandler (e) {
      if (e.keyCode === 13 && e.shiftKey) {
        e.preventDefault()
        this.content = `${this.content}\n`
      }
    },
    clickApprove () {
      this.form.selectedDate = [...this.seleted]
      this.control.showConfirmDateDialog = true
    },
    handleConfirmDate (confirm) {
      this.control.showConfirmDateDialog = false
      if (confirm) {
        // Continute to Ask for Reason
        this.form.reason = {
          from: '',
          type: '',
          detail: '',
          reason: '',
        }
        this.control.showReasonDialog = true
      }
    },
    saveReason () {
      this.control.showReasonDialog = false
      this.control.showConfirmRefundDialog = true
    },
    showSuccessRefund () {
      this.control.showRefundSuccessDialog = true
      let interval = setTimeout(() => {
        this.control.showRefundSuccessDialog = false
        clearTimeout(interval)
        this.$router.push({ name: 'PatientDetail', params: { id: this.id }, query: { tab: 'workcalendarTab' } })
      }, 3000)
    },
    async calculateRefund () {
      try {
        this.fullscreenLoading = true
        this.refundData = await this.$api.Reservation.calculaterefund(this.reservationId, this.form.selectedDate, parseInt(this.refundData.chargePercent))
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    handleRefund (refund) {
      this.control.showConfirmRefundDialog = false
      if (refund) {
        // Refund
        this.control.showRefundDialog = true
        this.calculateRefund()
      } else {
        // No Refund
        this.cancelReservation(false)
      }
    },
    refundAccept () {
      this.cancelReservation(true)
      this.control.showRefundDialog = false
      this.showSuccessRefund()
    },
    async cancelReservation (refund) {
      try {
        this.fullscreenLoading = true
        if (this.isPartial) {
          await this.$api.Reservation.cancelpartial(this.reservationId, this.form.selectedDate, this.form.reason, refund, parseInt(this.refundData.chargePercent))
        } else {
          await this.$api.Reservation.cancel(this.reservationId, this.form.selectedDate[0], this.form.reason, refund, parseInt(this.refundData.chargePercent))
        }
        this.showSuccessRefund()
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    handleIsPartial () {
      this.control.showIsPartialDialog = false
      this.isPartial = this.isPartialForm
    },
    changeDateFormat (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    calculateDateFormat () {
      let d = this.sort_unique([...this.form.selectedDate])
      let start = d[0]
      let datesList = []
      for (let i = 1; i < d.length; i++) {
        let addDay = moment(d[i - 1]).add(1, 'days').format('YYYY-MM-DD')
        if (!moment(addDay).isSame(d[i])) {
          if (start === d[i - 1]) datesList.push(this.changeDateFormat(start))
          else datesList.push(`${this.changeDateFormat(start)} - ${this.changeDateFormat(d[i - 1])}`)
          start = d[i]
        }
      }
      if (start === d[d.length - 1]) datesList.push(this.changeDateFormat(start))
      else datesList.push(`${this.changeDateFormat(start)} - ${this.changeDateFormat(d[d.length - 1])}`)
      return datesList
    },
    sort_unique (raw) {
      if (raw.length === 0) return raw
      raw = raw.sort((a, b) => moment(a) - moment(b))
      let ds = [raw[0]]
      for (let i = 1; i < raw.length; i++) {
        if (raw[i - 1] !== raw[i]) {
          ds.push(raw[i])
        }
      }
      return ds
    },
  },
}
</script>
